<template>
  <ChecklistBlockBase
    :buttonsData="editorMetadata.buttonsData"
    :buttonsPreset="'copy'"
    @commonAction="(action) => $emit('commonAction', action)"
  >
    <WhiteIQOS
      noOverflow
      bodyClass="checklist-block-iqos-body"
      :subtitle=" $t('checklist_blocks.number.subtitle')"
    >
      <template #title>
        <BaseIcon size="sm3" icon="hash" />
        {{ $t("checklist_blocks.number.title") }}
      </template>

      <div class="checklist-block-iqos-body-block">
        <BaseTextInput @blur="$emit('commonAction', 'update')" v-model="block.title" size="md" :placeholder=" $t('checklist_blocks.title_ph')" />
      </div>

      <BaseDivider color="border-base-tertiary" />

      <div class="number-options">
        <div class="gap-row-1xs">
          <div class="qrw-label-lg bold qrw-text-content-base-primary">
            {{ $t("checklist_blocks.number.prefix_title") }}
          </div>
          <div class="qrw-label-sm qrw-text-content-base-secondary">
            {{ $t("checklist_blocks.number.prefix_desc") }}
          </div>
        </div>
        <div class="options-inputs">
          <BaseTextInput
            size="md"
            v-model="block.number.prefix"
            @blur="$emit('commonAction', 'update')"
            :placeholder="$t('checklist_blocks.number.prefix_ph')"
          />
          <div class="number-placeholder bold qrw-paragraph-md">
            {{ $t("checklist_blocks.number.number_ph") }}
          </div>
          <BaseTextInput
            size="md"
            v-model="block.number.suffix"
            @blur="$emit('commonAction', 'update')"
            :placeholder="$t('checklist_blocks.number.suffix_ph')"
          />
        </div>
      </div>

      <div class="number-options">
        <div class="gap-row-1xs">
          <div class="qrw-label-lg bold qrw-text-content-base-primary">
            {{ $t("checklist_blocks.number.range_title") }}
          </div>
          <div class="qrw-label-sm qrw-text-content-base-secondary">
            {{ $t("checklist_blocks.number.range_desc") }}
          </div>
        </div>
        <div class="options-inputs">
          <div class="gap-row-1xs w-100">
            <div class="qrw-label-sm qrw-text-content-base-primary">
              {{ $t("checklist_blocks.number.range_min") }}
            </div>
            <BaseNumberInput
              size="md"
              v-model.number="block.number.min_value"
              @blur="$emit('commonAction', 'update')"
              placeholder="0"
            />
          </div>
          <div class="gap-row-1xs w-100">
            <div class="qrw-label-sm qrw-text-content-base-primary">
              {{ $t("checklist_blocks.number.range_max") }}
            </div>
            <BaseNumberInput
              size="md"
              v-model.number="block.number.max_value"
              @blur="$emit('commonAction', 'update')"
              placeholder="0"
            />
          </div>
        </div>
      </div>

      <template #footer>
        <BlockAssignOption
          :optionsBlocks="editorMetadata.optionsBlocksAbove"
          :block="block"
          @assigned="$emit('commonAction', 'update')"
          v-if="editorMetadata.canAssignOptions"
        />
        <BaseDivider
          color="border-base-secondary"
          v-if="editorMetadata.canAssignOptions"
        />
        <CommonBlockSettings @update="$emit('commonAction', 'update')" :block="block" />
      </template>
    </WhiteIQOS>
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";
import BlockAssignOption from "../BlockAssignOption.vue";
import CommonBlockSettings from "../CommonBlockSettings.vue";

export default {
  props: {
    block: Object,
    editorMetadata: Object,
  },
  components: {
    ChecklistBlockBase,
    BlockAssignOption,
    CommonBlockSettings,
  },
};
</script>

<style scoped>
.number-options {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 24px 16px;
  box-sizing: border-box;
  width: 100%;
}

.options-inputs {
  display: flex;
  flex-direction: row;
  column-gap: 12px;
  width: 100%;
}

.number-placeholder {
  height: 40px;
  background: var(--qrw-background-base-tertiary);
  text-align: center;
  display: flex;
  align-items: center;
  padding: 8px;
  width: 100%;
  justify-content: center;
  border-radius: 4px;
  box-sizing: border-box;
}
</style>
